import { AccordionButton, AccordionIcon, AccordionItem, AccordionPanel, Box, Text } from "@biblioteksentralen/react";
import { capitalize } from "radash";
import FilterOptions from "./FilterOptions";
import { Filteredtems } from "./getFilteredItems";
import { Filter, FilterableItem } from "./useFilter";

interface Props<T extends FilterableItem> {
  filter: Filter<T>;
  filteredItems: Filteredtems<T>;
}

const FilterMenuAccordion = <T extends FilterableItem>({ filter, filteredItems }: Props<T>) => (
  <AccordionItem>
    <h2>
      <AccordionButton>
        <Box flex="1" textAlign="left">
          <Text fontWeight={600}>{capitalize(filter.label || filter.key)}</Text>
        </Box>
        <AccordionIcon />
      </AccordionButton>
    </h2>
    <AccordionPanel paddingBottom="1rem">
      <FilterOptions filter={filter} filteredItems={filteredItems} />
    </AccordionPanel>
  </AccordionItem>
);

export default FilterMenuAccordion;
